import { apiSlice } from 'src/features/api/api-slice';
import { ApiResponse } from 'src/common/interfaces';
import { RTKQueryTag } from 'src/common/constants';

import { SubmissionsData, SubmissionsParams, TestersData, UpdateSubmissionsParams } from './submissions.types';
import { ADMIN_SUBMISSIONS_URL } from './submissions.constants';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSubmissions: builder.query<ApiResponse<SubmissionsData>, SubmissionsParams>({
      query: ({ page, limit, search, sort, status, tester }: SubmissionsParams) => ({
        url: ADMIN_SUBMISSIONS_URL,
        params: {
          page,
          limit,
          search,
          sort,
          status,
          tester,
        },
        method: 'GET',
      }),
      providesTags: [RTKQueryTag.Submissions],
    }),
    updateSubmission: builder.mutation<ApiResponse, UpdateSubmissionsParams>({
      query: (body) => ({
        url: ADMIN_SUBMISSIONS_URL,
        method: 'PUT',
        body,
      }),
      invalidatesTags: [RTKQueryTag.Submissions],
    }),
    getUniqueTesters: builder.query<ApiResponse<TestersData[]>, void>({
      query: () => ({
        url: 'admin/unique-testers',
        method: 'GET',
      }),
      providesTags: [RTKQueryTag.Submissions],
    }),
  }),
});

export const { useGetSubmissionsQuery, useUpdateSubmissionMutation, useGetUniqueTestersQuery } = extendedApiSlice;
